import React from 'react';

/**
 * Tabla con formato de documento: bordes, encabezado sombreado y todas las filas
 * a la vista. Replica el panel en Word, por eso no usa el Table del design system,
 * que pagina y ordena. Para leer y para imprimir, no para explorar.
 *
 * columnas: [{ label, ancho, clase, render(fila) }]
 */
const TablaDoc = ({ columnas, filas = [], textoVacio }) => {
  if (filas.length === 0) {
    return <p className='ap-vacio'>{textoVacio}</p>;
  }

  return (
    <div className='ap-doc-wrap'>
      <table className='ap-doc'>
        <colgroup>
          {columnas.map((c, i) => (
            <col key={i} style={c.ancho ? { width: c.ancho } : undefined} />
          ))}
        </colgroup>
        <thead>
          <tr>
            {columnas.map((c, i) => (
              <th key={i}>{c.label}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {filas.map((fila, f) => (
            <tr key={fila.deal_id ?? fila.consultor ?? f}>
              {columnas.map((c, i) => (
                <td key={i} className={c.clase}>
                  {c.render(fila)}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default TablaDoc;
